<script>
export default {
    name: "NextOfKinTab",

    props: {

        nextOfKins: Array,
    },
}
</script>
<template>
<div class="md:w-3/4 sm:w-full overflow-auto mt-1">
    <table class="table table-hover">
        <thead class="bg-blue-500 text-sm text-white">
            <tr class="flex w-full">
                <th class="p-tiny w-1/4">Name</th>
                <th class="p-tiny w-1/4">Relationship</th>
                <th class="p-tiny w-1/4">Telephone</th>
                <th class="p-tiny w-1/4">Address</th>
            </tr>
        </thead>
        <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:25vh;">
            <tr v-for="(nextOfKin, idx) in nextOfKins" :key="idx" class="flex w-full">
                <td class="p-tiny w-1/4">{{ nextOfKin.name }}</td>
                <td class="p-tiny w-1/4">{{ nextOfKin.relationship }}</td>
                <td class="p-tiny w-1/4">{{ nextOfKin.telephone }}</td>
                <td class="p-tiny w-1/4">{{ nextOfKin.address }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>